import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledInfoLabel = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

const StyledTable = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 13px;
	margin-top: 17px;
`;

const StyledRow = styled.div`
	display: flex;
	justify-content: space-between;

	${Text} {
		font-size: 16px;
		color: #ffffff;

		&:nth-child(2n + 1) {
			opacity: 0.25;
		}
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 26px;
`;

export { StyledButtonsContainer, StyledInfoLabel, StyledRow, StyledTable };
